import { updateBook } from "../../../books/actions";
import { changeSubmitMode } from "../../../form/action";

const editBook = (book) => {
  return async (dispatch) => {
    const response = await fetch(`http://localhost:9000/books/${book.id}`, {
      method: "PATCH",
      body: JSON.stringify({
        ...book,
      }),
      headers: {
        "Content-type": "application/json; charset=UTF-8",
      },
    });
    const edittedBook = await response.json();

    dispatch(updateBook(edittedBook));
    dispatch(changeSubmitMode(false));
  };
};

export default editBook;
